import api from '@/api/index'

export default {
    methods: {
        async handle_table_export_action (action, selection, search_param) {
            this.loading = true
    
            let params = {}
            if (action === 'export-selected') {
              if (Array.isArray(selection) && selection.length > 0) {
                params = {
                  'system_id': {
                    value: selection.map(article=>article['system_id']),
                    action: 'in'
                  }
                }
              }
            }
            else if (action === 'export-filtered') {
              params = search_param
              delete params['page_num']
              delete params['page_limit']
            }
    
            let res = await api.export_article(params)
            if (res.success === true) {
              this.notify_message(this.ERROR.LEVEL.SUCCESS, '成功匯出資料', res.message)
            }
            else {
              this.notify_message(this.ERROR.LEVEL.ERROR, '無法匯出資料', res.message)
            }
            
            this.loading = false
          },
          async handle_export_button_click () {
            this.loading = true
    
            let params = {
              'system_id': {
                value: this.article_id,
                action: '='
              }
            }
    
            let res = await api.export_article(params)
            if (res.success === true) {
              this.notify_message(this.ERROR.LEVEL.SUCCESS, '成功匯出資料', res.message)
            }
            else {
              this.notify_message(this.ERROR.LEVEL.ERROR, '無法匯出資料', res.message)
            }
            
            this.loading = false
      },
    },
}